var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "+_vm._s(_vm.perUpgrade)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.tickspeedDisplay)+" "),_c('br'),_c('GameSpeedDisplay')],1)}
var staticRenderFns = []

export { render, staticRenderFns }